// extracted by mini-css-extract-plugin
export var banner = "_cd-0";
export var closeButton = "_cd-2";
export var greenCheckmark = "_cd-3";
export var hereLink = "_cd-4";
export var titleIcon = "_cd-1";